import { FiUser, FiMapPin, FiUsers, FiSettings } from 'react-icons/fi';

export type Page = 'identities' | 'locations' | 'contacts' | 'settings';

export const navigationItems = [
  { id: 'identities' as const, icon: FiUser, label: 'Identities' },
  { id: 'locations' as const, icon: FiMapPin, label: 'Locations' },
  { id: 'contacts' as const, icon: FiUsers, label: 'Contacts' },
  { id: 'settings' as const, icon: FiSettings, label: 'Settings' },
] as const;